export const ACTIVE_MEMBER_COLOR = "#3288BD";
export const ACTIVE_ALIGNMENT_COLOR = "black";
export const INACTIVE_ALIGNMENT_COLOR = "#9DA0A646";
export const INACTIVE_ALIGNMENT_CROSS_FILL = "#9DA0A613";
export const INACTIVE_ALIGNMENT_CROSS_STROKE = "#9DA0A626";
